import axios from "axios"
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest, ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json";
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { DetallePlanificacionUnidadesHE, MesesPlanificacionHEDTO, ReversarUnidadPlanificacion, ReversarUnidadPlanificaciones, UnidadesPlanificacionHEDTO } from "./TypesPlanificacionUnidades";
import { AtenderSolicitudReverso } from "../Proyeccion Horas Extras/TypesProyecionHorasExtrasAdmin";
import { DownloadDocumentWithAPI } from "helpers/files";
import { downloadExcelReport } from "helpers/downloadExcelReport";

export async function ObtenerAniosPlanificacionHE() {
    const url = configData.SERVER_URL + "PlanificacionHorasExtras/ObtenerAniosPlanificaciones";
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionPlanificacion: number[] = []

    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionPlanificacion }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }
        }
    }
    return infoResponse;
}

export async function ObtenerMesesPlanificacionHE(anio: number) {
    const url = configData.SERVER_URL + `PlanificacionHorasExtras/ObtenerMesesPorAnio/${anio}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionPlanificacion: MesesPlanificacionHEDTO[] = []

    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionPlanificacion }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }
        }
    }
    return infoResponse;
}

export async function ObtenerInformacionPlanificacionUnidadesHE(anio: number, mes: number) {

    const url = configData.SERVER_URL + `PlanificacionHorasExtras/ObtenerInformacionPlanificacionesUnidades/${anio}/${mes}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionPlanificacion: DetallePlanificacionUnidadesHE = { 
        listadoRegimenLaboralesPlan: [],
        unidadesPlanificacion: [],
        listadoRegimenLaborales: [],
        planificacionTotal:{
            valorTotalizadoRegimen: [],
            valorTotalPlanificacion: 0
        }
    }
    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionPlanificacion }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }
            
        }
    }

    return infoResponse;

}

export async function PutAtenderSolicituReverso(info:AtenderSolicitudReverso){
    var respuesta:ResponseRequestGeneric<void>= {
        status:-1
    };
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const url = configData.SERVER_URL + `PlanificacionHorasExtras/TH/SolicitudReverso`;
    try {

        const responseAxios = await axios.put(url,info,
        {
            headers: authHeaderWithUserData(infoUsuario)
        })


        respuesta = {
            status : responseAxios.status,
        }
        
        
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuesta = {
                status: error.response.status
            }
            
        }
    }

    return respuesta
}


export async function PutReversarUnidad(info:ReversarUnidadPlanificacion){
    var respuesta:ResponseRequestGeneric<void>= {
        status:-1
    };
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const url = configData.SERVER_URL + `PlanificacionHorasExtras/TH/ReversoPlanificacionUnidad`;
    try {

        const responseAxios = await axios.put(url,info,
        {
            headers: authHeaderWithUserData(infoUsuario)
        })


        respuesta = {
            status : responseAxios.status,
        }
        
        
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            console.log(error)
            respuesta = {
                status: error.response.status,
                errorMessage:error.response.data
            }
            
        }
    }

    return respuesta
}

export async function PutReversarUnidades(info:ReversarUnidadPlanificaciones){
    var respuesta:ResponseRequestGeneric<void>= {
        status:-1
    };

    const infoUsuario: UserData = authenticationService.currentUserValue;
    const url = configData.SERVER_URL + `PlanificacionHorasExtras/TH/ReversoPlanificacionesUnidad`;
    try {

        const responseAxios = await axios.put(url,info,
        {
            headers: authHeaderWithUserData(infoUsuario)
        })


        respuesta = {
            status : responseAxios.status,
        }
        
        
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuesta = {
                status: error.response.status
            }
            
        }
    }

    return respuesta
}

export async function ObtenerReportePlanificacionesUnidadesTH(mes: number, anio: number){    

    const url = configData.SERVER_URL + `PlanificacionHorasExtras/TH/ReportePDFPlanificacionUnidades/${anio}/${mes}`;
    await DownloadDocumentWithAPI(url,authenticationService.currentUserValue.token,"REPORTE PLANIFICACIÓN UNIDADES.pdf")
}

export async function ObtenerReporteExcelPlanificacionesUnidadesTH(mes: number, anio: number){
    
    const url = `PlanificacionHorasExtras/TH/ReporteExcelPlanificacionUnidades/${anio}/${mes}`;
    await downloadExcelReport(url,"REPORTE PLANIFICACIÓN UNIDADES.xlsx")
}
